import { Route, Routes } from "react-router-dom";

import PriceRemarkProductivity from "./list";

export default function PriceRemarkProductivityRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PriceRemarkProductivity />} />
    </Routes>
  );
}
